(function() {
  function initSetSearch() {
    var details = null;
    var labels = document.querySelectorAll('.facets__summary-label');
    labels.forEach(function(lbl) {
      if (lbl.childNodes[0] && lbl.childNodes[0].textContent.trim() === 'Set') {
        details = lbl.closest('details');
      }
    });
    if (!details || details.dataset.searchBound) return;
    details.dataset.searchBound = 'true';
    var display = details.querySelector('.facets__display, .facets__display-vertical');
    if (!display) return;
    var wrapper = document.createElement('div');
    wrapper.style.cssText = 'padding: 8px 8px 4px;';
    var inp = document.createElement('input');
    inp.type = 'text';
    inp.placeholder = 'Search sets...';
    inp.style.cssText = 'width: 100%; padding: 6px 10px; border: 1px solid #ccc; border-radius: 4px; font-size: 13px; box-sizing: border-box;';
    inp.addEventListener('input', function(e) {
      e.stopImmediatePropagation();
      e.stopPropagation();
      e.preventDefault();
      var q = this.value.toLowerCase();
      var items = details.querySelectorAll('li.list-menu__item');
      items.forEach(function(item) {
        var label = item.querySelector('.facet-checkbox__text-label');
        if (!label) return;
        var matches = label.textContent.toLowerCase().indexOf(q) !== -1;
        item.style.display = (q === '') ? (item.classList.contains('show-more-item') ? 'none' : '') : (matches ? '' : 'none');
      });
    }, true);
    inp.addEventListener('keydown', function(e) { e.stopImmediatePropagation(); e.stopPropagation(); }, true);
    inp.addEventListener('change', function(e) { e.stopImmediatePropagation(); e.stopPropagation(); }, true);
    wrapper.appendChild(inp);
    display.insertBefore(wrapper, display.firstChild);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSetSearch);
  } else {
    initSetSearch();
  }
  document.addEventListener('facets:updated', initSetSearch);
  document.addEventListener('shopify:section:load', initSetSearch);
})();
